import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface UserInfoResponse {
  user_id: string;
  user_name: string;
  organization?: string;
  super_org?: string;
  specialty?: string;
  user_email: string;
  created_at: string;
  model_type?: string;
}

export const dashboardUserInfoKeys = {
  all: ["dashboardUserInfo"] as const,
};

export function useDashboardUserInfo() {
  return useQuery({
    queryKey: dashboardUserInfoKeys.all,
    queryFn: async () => {
      const data = await api.get<UserInfoResponse[]>("/dashboard/userinfo");
      return data[0];
    },
  });
}

export default useDashboardUserInfo;
